import { useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";

import CustomModalWrapper from "../CustomModalV2/wrapper";
import DatePicker from "./DatePicker";

import { SetModalProperties, ShowModal } from "../../redux/v2/utils/actions";

import "./style.css";

function CustomDatePickerv2(props) {
    const { withCustomModal = true } = props;
    const location = useLocation();
    const [value, setValue] = useState("--/--/----");

    const onDateChange = (date) => {
        let d = date.format("MM/DD/YYYY");
        setValue(d);
        props?.onChange(d);
    };

    const isInside = location.pathname.includes("/account");

    return (
        <div id="custom-date-picker-v2">
            <TextBoxComponent
                className="field"
                name="inputName"
                type="text"
                readOnly
                placeholder="Date of Birth"
                value={value == "--/--/----" ? "" : value}
                onClick={() => {
                    props.SetModalProperties({
                        height: "550px",
                        isShow: true,
                        title: "",
                        body: <DatePicker ShowModal={props?.ShowModal} onDateChange={onDateChange} />,
                        actions: [],
                    });
                }}
            />

            {(!isInside && withCustomModal) && <CustomModalWrapper />}
        </div>
    );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
    SetModalProperties,
    ShowModal,
})(CustomDatePickerv2);
